import { useSanityVisualEditingState } from "../composables/visual-editing.js";
import { defineNuxtPlugin, useRuntimeConfig, useSanityVisualEditing, useSanityLiveMode } from "#imports";
export default defineNuxtPlugin(() => {
  if (!useSanityVisualEditingState().enabled) return;
  const $config = useRuntimeConfig();
  const { visualEditing } = $config.public.sanity;
  if (visualEditing?.mode === "live-visual-editing" || visualEditing?.mode === "visual-editing") {
    useSanityVisualEditing({
      refresh: visualEditing?.refresh,
      zIndex: visualEditing?.zIndex
    });
  }
  if (visualEditing?.mode === "live-visual-editing") {
    useSanityLiveMode();
  }
});
